import React from 'react'
import { useSelector } from 'react-redux'
import styles from '../InternalExternalDetail.module.css'
import SectionHeader from './SectionHeader'

const CareerSummary = ({ mode }) => {
  const rawData = useSelector((state) => state.externalUserDetailReducer.rawData)

  const summaryText = mode === 'external'
    ? (rawData?.summary || '')
    : ''

  if (!summaryText) return null

  const paragraphs = summaryText.split('\n').map(s => s.trim()).filter(Boolean)

  return (
    <section className={styles.card}>
      <SectionHeader title="Career Summary" />
      <div className={styles.summaryText}>
        {paragraphs.map((para, i) => (
          <p key={i} className={styles.summaryPara}>{para}</p>
        ))}
      </div>
    </section>
  )
}

export default CareerSummary
